// src/utils/chainConfig.js
import { 
  mainnet, 
  bsc, 
  polygon, 
  base, 
  linea, 
  arbitrum, 
  optimism, 
  avalanche, 
  celo, 
  mantle,      // FIXED: dulunya mantlenet
  scroll, 
  sei,
  zksync,      // FIXED: lowercase
  opBNB, 
  blast, 
  palm,
  // Chain baru dari log error Anda (pastikan wagmi versi terbaru)
  hemi,
  megaeth,
  monad,
  swellchain,
  unichain
} from 'wagmi/chains';
import { http } from 'wagmi';

const INFURA_KEY = '64b941c50c70471882f4060aee16f0e9';

// Helper transport
const createTransport = (subdomain) => {
  return http(`https://${subdomain}.infura.io/v3/${INFURA_KEY}`);
};

// Daftar Chain Lengkap
export const supportedChains = [
  bsc, // Default Primary
  mainnet,
  polygon,
  base,
  linea,
  arbitrum,
  optimism,
  avalanche,
  celo,
  mantle,
  scroll,
  sei,
  zksync,
  opBNB,
  blast,
  palm,
  hemi,
  megaeth,
  monad,
  swellchain,
  unichain
];

// Mapping Transports
export const chainTransports = {
  [bsc.id]: http('https://bsc-mainnet.infura.io/v3/' + INFURA_KEY),
  [mainnet.id]: createTransport('mainnet'),
  [polygon.id]: createTransport('polygon-mainnet'),
  [base.id]: createTransport('base-mainnet'),
  [linea.id]: createTransport('linea-mainnet'),
  [arbitrum.id]: createTransport('arbitrum-mainnet'),
  [optimism.id]: createTransport('optimism-mainnet'),
  [avalanche.id]: createTransport('avalanche-mainnet'),
  [celo.id]: createTransport('celo-mainnet'),
  [mantle.id]: createTransport('mantle-mainnet'), // Jika tersedia di infura, atau fallback public
  [scroll.id]: createTransport('scroll-mainnet'),
  [opBNB.id]: http(), // Use public RPC fallback
  [zksync.id]: http(), 
  [blast.id]: createTransport('blast-mainnet'),
  [palm.id]: createTransport('palm-mainnet'),
  // Chain baru fallback ke default public RPC mereka
  [sei.id]: http(),
  [hemi.id]: http(),
  [megaeth.id]: http(),
  [monad.id]: http(),
  [swellchain.id]: http(),
  [unichain.id]: http(),
};